import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function Quality() {
  const page = "quality";
  return (
    <div>
      <section className={`hero ${page}`}>
        <h1>Quality</h1>
      </section>

      <Breadcrumbs
          items={[
              { label: "Home", to: "/" },
              { label: "About", to: "/about" },
              { label: "Quality" }, // no `to` = current page
      ]}
      />

      <section className="section section--white">
        <div className="fullscreen-kicker">
          <h3>Excellence Without Compromise</h3>
        </div>
        <div className="container">
          <p>
            At <strong>DMCO</strong>, quality is more than compliance—it is the foundation of our drilling materials business. Every batch of drilling materials produced at our factory is engineered with precision to meet the highest 
            performance standards, ensuring our customers achieve reliability and efficiency even in the most demanding drilling operations.
          </p>
        </div>
      </section>

      <section className="section section--grey">
        <div className="fullscreen-kicker">
          <h3>Certified Quality Standards</h3>
        </div>
        <div className="container">
          <p>
            Our commitment is reinforced by globally recognized certifications:
          </p>
          <ul className="kpi-list">
            <li><strong>ISO 9001 (Quality Management)</strong>ensures our processes are consistent, measurable, and continually improving.</li>
            <li><strong>ISO 14001 (Environmental Management)</strong> integrates sustainability into our operations, minimizing environmental impact.</li>
            <li><strong>ISO 45001 (Occupational Health & Safety)</strong> safeguards our workforce, ensuring safe practices are translated into safe, reliable products.</li>
            <li><strong>ISO 27001 (Information Security)</strong> is currently in progress, further strengthening customer trust in our data security and digital systems.</li>
          </ul>        
        </div>
      </section>    

      <section className="section section--white">
        <div className="fullscreen-kicker">
          <h3>A Culture of Continuous Improvement</h3>
        </div>
        <div className="container">
          <p>
            We constantly monitor production processes, conduct rigorous product testing, and integrate customer feedback to raise the bar of performance. This ensures our drilling materials are not just manufactured to 
            specification but are proven to deliver reliability and consistency in the field.
          </p>
        </div>
      </section>

      <section className="section section--grey">
        <div className="fullscreen-kicker">
          <h3>Quality for Our Customers</h3>
        </div>
        <div className="container">
          <p>
            Quality at DMCO is not an internal goal—it is a customer promise. By ensuring durability, consistency, and compliance, we empower our customers to execute their drilling projects with greater confidence, 
            reduced downtime, and improved results.
          </p>
        </div>
      </section>      
    </div>
  )
}

export default Quality